module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAIVJREFUGBl9kEEOgCAMBIk3Dx71DRpfof8/+heP2gGKKxg3KS3bbikNIWE11+e4dvDkIwgus8NsisxzcIcnHwUonVDBWPHlZe2AYK4KEb6ggtMyPlpT6KrFAi/E88IndEYXMFLTWQt/Z6634Z30DzQYmEf37IXwQAVbopKg7NHJ7Om4m3U3lBcse0uHbgUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_cancel_black.png
// module id = 17
// module chunks = 0